import React from 'react';
import { X, RefreshCw, AlertCircle } from 'lucide-react';

const CloneProductModal = ({
    show,
    onClose,
    cloneProduct,
    setCloneProduct,
    onConfirm,
    groups
}) => {
    if (!show || !cloneProduct) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-gray-900 rounded-lg border border-gray-800 w-full max-w-lg">
                <div className="p-6 border-b border-gray-800 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <RefreshCw className="w-6 h-6 text-blue-400" />
                        <h2 className="text-xl font-bold">Clone Product</h2>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-white transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    <div>
                        <label className="block text-sm font-medium mb-2">Product ID</label>
                        <input
                            type="text"
                            value={cloneProduct.id}
                            onChange={(e) => setCloneProduct({ ...cloneProduct, id: e.target.value })}
                            placeholder="e.g., nexus-api-gateway"
                            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        />
                        <p className="text-xs text-gray-400 mt-1">Format: letters, numbers, hyphens, underscores (e.g., nexus-api-gateway, unidash-1)</p>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Product Name</label>
                        <input
                            type="text"
                            value={cloneProduct.name}
                            onChange={(e) => setCloneProduct({ ...cloneProduct, name: e.target.value })}
                            placeholder="Product name"
                            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Description (Optional)</label>
                        <textarea
                            value={cloneProduct.description}
                            onChange={(e) => setCloneProduct({ ...cloneProduct, description: e.target.value })}
                            placeholder="Product description"
                            rows={2}
                            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white resize-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Group</label>
                        <select
                            value={cloneProduct.group_id || ''}
                            onChange={(e) => setCloneProduct({ ...cloneProduct, group_id: e.target.value ? parseInt(e.target.value) : null })}
                            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        >
                            <option value="">Select a group...</option>
                            {groups.map((group) => (
                                <option key={group.id} value={group.id}>
                                    {group.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Version URL (Optional)</label>
                        <input
                            type="text"
                            value={cloneProduct.version_url}
                            onChange={(e) => setCloneProduct({ ...cloneProduct, version_url: e.target.value })}
                            placeholder="https://example.com/version"
                            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Color</label>
                        <select
                            value={cloneProduct.color}
                            onChange={(e) => setCloneProduct({ ...cloneProduct, color: e.target.value })}
                            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        >
                            <option value="blue">Blue</option>
                            <option value="green">Green</option>
                            <option value="red">Red</option>
                            <option value="yellow">Yellow</option>
                            <option value="purple">Purple</option>
                            <option value="pink">Pink</option>
                            <option value="indigo">Indigo</option>
                            <option value="orange">Orange</option>
                        </select>
                    </div>

                    <div className="p-3 bg-blue-500/10 border border-blue-500/30 rounded-lg">
                        <div className="flex items-start gap-2">
                            <AlertCircle className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                            <div className="text-xs text-blue-400">
                                This will create a new product with the settings above. Deployment history will not be copied.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-6 border-t border-gray-800 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        Clone Product
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CloneProductModal;
